import { create } from "zustand";
import { CartStateType } from "../src/types";

export const cartStateStore = create<CartStateType>((set) => ({
  open: false,
  setOpen: (val) => set(() => ({ open: val })),
}));

export default cartStateStore;
